/**
 * Export component file to be used on project
 */

import NpsResponse from './NpsResponse';
export default NpsResponse;